export default __webpack_public_path__ + "static/media/ge.d4167ddb.svg";